export default __webpack_public_path__ + "static/image7-8752e407adc41c410a479996f6ef12c0.gif";